import { SelectionModel } from "@angular/cdk/collections";
import { Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { Extensions } from "src/app/helpers/extensions";
import { Associate } from "src/app/models/associate";
import { Event } from "src/app/models/event";
import { EntryService } from "src/app/services/entry.service";
import { NotificationService } from "src/app/services/notification.service";

@Component({
    selector: 'app-add-event',
    templateUrl: './add-event.component.html',
    styleUrls: ['./add-event.component.scss']
})

export class AddEventComponent implements OnInit {
    form: UntypedFormGroup;
    editMode: boolean;
    associates: Associate[] = [];
    dataSource = new MatTableDataSource<Associate>();
    locationBranches: string[] = [];
    displayedColumns: string[] = ['select', 'description', 'locationBranch'];
    selection = new SelectionModel<Associate>(true, []);
    panelOpenState: boolean = false;

    @ViewChild('userInput') userInput: ElementRef<HTMLInputElement>;
    @ViewChild('descriptionInput') descriptionInput: ElementRef<HTMLTextAreaElement>;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddEventComponent>, private notificationService: NotificationService,
        private entryService: EntryService) {
        this.editMode = this.data?.event != null;
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            date: new UntypedFormControl(null, [Validators.required]),
            title: new UntypedFormControl(null, [Validators.required, Validators.maxLength(30)]),
            description: new UntypedFormControl(null, [Validators.required, Validators.maxLength(200)]),
            location: new UntypedFormControl(null, [Validators.required, Validators.maxLength(100)]),
            selectAssociatesIndividually: new UntypedFormControl(false),
            locationBranch: new UntypedFormControl(null),
        });

        this.entryService.getAssociates({ activeOnly: true }).subscribe({
            next: associates => {
                this.associates = associates;
                this.dataSource.data = associates;
                this.locationBranches = Extensions.distinct(associates.map(a => a.locationBranch), b => b);

                if (this.editMode) {
                    let event: Event = this.data.event;

                    this.form.patchValue({
                        date: event.date, title: event.title,
                        description: event.description, location: event.location,
                        locationBranch: event.locationBranch
                    });

                    this.filterAssociates(false);
                    this.dataSource.data.forEach(a => {
                        if (event.participants.map(p => p.associateID).includes(a.id)) {
                            this.selection.select(a);
                        }
                    });
                }
            },
            error: error => {
                this.notificationService.error(error);
            }
        });
    }

    ngAfterViewInit() {
        if (this.editMode && this.descriptionInput != null) {
            this.descriptionInput.nativeElement.style.height = this.descriptionInput.nativeElement.scrollHeight + 'px';
        }
    }

    filterAssociates(updateSelection: boolean = true) {
        this.dataSource.data = this.associates.filter(a => (this.form.value.locationBranch == null || a.locationBranch == this.form.value.locationBranch));
        this.selection.clear();

        if (this.form.value.locationBranch != null && updateSelection) {
            this.selection.setSelection(...this.dataSource.data);
        }
    }

    applyFilter = (value: string) => {
        this.dataSource.filter = value.trim().toLocaleLowerCase();
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(a => this.selection.select(a));
    }

    save() {
        if (this.form.invalid) {
            this.notificationService.warning('Existem campos não preenchidos.');
            return;
        }

        if (this.selection.selected.length <= 0) {
            this.notificationService.warning('Selecione pelo menos um convidado.');
            return;
        }

        this.dialogRef.close({
            date: this.form.value.date,
            title: this.form.value.title,
            description: this.form.value.description,
            location: this.form.value.location,
            locationBranch: this.form.value.locationBranch,
            associates: this.selection.selected.map(a => a.id),
        });
    }

    cancel() {
        this.dialogRef.close();
    }

    getEventDescription() {
        var description = this.form.value.description;
        return description?.trim().length > 0 ? this.form.value.description.replace(/\n/g, '<br>') : 'Descrição da publicação';
    }

    currentDateTime() {
        return Date.now();
    }
}